import NewsRepository from '@/repositories/NewsRepository'
import VoiceRepository from '@/repositories/VoiceRepository'
import NewsEntity from '@/entities/News'
import VoiceEntity from '@/entities/Voice'
import MetaRepository from '@/repositories/MetaRepository'
import dayjs from 'dayjs'
import { DATE_TIME_FORMAT } from '@/const'

export interface IPresenterParams {
  newsRepository: NewsRepository
  voiceRepository: VoiceRepository
  featuredNewsId: string | null
  metaRepository: MetaRepository
}

export interface IPresenter {
  newsList: NewsEntity[]
  voices: VoiceEntity[]
  news: NewsEntity[]
  serverTimestamp: string | null
}

export default ({ newsRepository, voiceRepository, featuredNewsId, metaRepository }: IPresenterParams): IPresenter => {
  const featuredNews = featuredNewsId ? newsRepository.getNewsById(featuredNewsId) : null
  const newsList = featuredNews ? [featuredNews] : []
  let serverTimestamp = metaRepository.getLatestServerTimestamp()
  if (serverTimestamp) serverTimestamp = dayjs(serverTimestamp, DATE_TIME_FORMAT).format('YYYY-MM-DD HH:mm:ss')

  return {
    newsList: newsRepository.getNewsList({ limit: 4 }),
    voices: voiceRepository.getVoices({ limit: 4 }),
    news: newsList,
    serverTimestamp
  }
}
